import { r as registerInstance, c as createEvent, h, g as getElement } from './index-16dc7dde.js';
import './lookups-705fb53e.js';
import { j as join } from './path-9b025204.js';
import { T as TAB_NAMES } from './analytics-765d4daf.js';
import './request.constants-deb285e0.js';
import { N as NAVIGATION_STATE_PARAM_NAME, M as getCountry, O as getLanguage, P as processGlobalAnalyticsEvent, Q as OFFSET_PARAM_NAME, R as PRODUCTS_PER_PAGE_PARAM_NAME, S as getNavigationState, T as replacePlusWithSpace, g as getData, U as changeCategoriesFields, V as normalizeFilters, W as clearNormalizedFilterData, X as getProductsUrl, a as isMobile } from './utils-15ad90ec.js';
import { i as isEmpty_1 } from './isEmpty-b60327cb.js';
import { p as parseRecords, t as tryParse } from './parsers-e38ff6a5.js';
import { g as getFiltersUrl } from './urls-89a1db69.js';
import { R as RANGE_ENDPOINT, L as LOCALE_REGEXP } from './constants-afaa9f0a.js';
import { c as calculateCurrentNodeParams, g as getRangeNodesIds, a as getCurrentReference } from './range-helpers-2dd7a4ef.js';
import { g as getNodeIds, a as getSeoUrl } from './filters-cec8ceba.js';
import './_commonjsHelpers-ba3f0406.js';
import './send-33ade633.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './isTypedArray-dfccd669.js';

const rangeTabsCss = ":host{display:block;box-sizing:border-box;--document-listing-top-margin:0;--document-listing-top-margin-mobile:0}:host *,:host *::before,:host *::after{box-sizing:inherit}.range-tabs{width:100%;height:100%}pes-document-listing .document-listing-container{box-sizing:border-box;background:transparent}pes-document-listing .document-listing-container *,pes-document-listing .document-listing-container *::before,pes-document-listing .document-listing-container *::after{box-sizing:inherit}";

let RangeTabs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.nodeSelected = createEvent(this, "nodeSelected", 7);
    this.endpoint = RANGE_ENDPOINT;
    this.name = 'TODO';
    this.enableCommerceConnector = true;
    this.showBuyOnline = true;
    this.nodes = [];
    this.products = [];
    this.productsCount = 0;
    this.isTabsInitialized = false;
    this.isMobileCategorySelected = false;
    this.isLoading = false;
    this.documentsTabEnabled = {
      [TAB_NAMES.Documents]: false,
      [TAB_NAMES.Software]: false,
    };
    this.pills = [];
    this.PBSoffset = 0;
    this.isHighLevelNode = false;
    this.isFirstRenderOfNodes = false;
    this.nodesNavigation = [];
    this.handlePopState = (event) => {
      var _a;
      if (!this.isPBS) {
        const { offset, productsPerPage } = this.paginationParams;
        const searchParams = new URLSearchParams(window.location.search);
        this.navigationState = searchParams.has(NAVIGATION_STATE_PARAM_NAME)
          ? searchParams.get(NAVIGATION_STATE_PARAM_NAME)
          : ((_a = event.state) === null || _a === void 0 ? void 0 : _a.navigationState) || this.initialNavigationState;
        this.selectedPage = Math.floor(offset / productsPerPage) + 1;
        this.loadFilters();
      }
    };
    this.renderPresentationTab = () => {
      var _a;
      return (((_a = this.tabs) === null || _a === void 0 ? void 0 : _a.presentation) && (h("pes-range-presentation-tab", { presentation: this.tabs.presentation })));
    };
    this.renderWebinarsAndResources = () => {
      var _a;
      return (((_a = this.tabs) === null || _a === void 0 ? void 0 : _a.webinarsAndResources) && (h("pes-range-webinars-and-resources-tab", { webinarAndResources: this.tabs.webinarsAndResources })));
    };
    this.renderProductsTab = () => (h("pes-range-products-tab", { labels: {
        commonFiltersFilterBy: this.commonFiltersFilterBy,
        facetButtonResetAllLabel: this.facetButtonResetAllLabel,
        rangeProductsFiltersLabel: this.rangeProductsFiltersLabel,
        facetButtonViewMoreFilters: this.facetButtonViewMoreFilters,
        facetButtonViewLessFilters: this.facetButtonViewLessFilters,
        previousLabel: this.previousLabel,
        nextLabel: this.nextLabel,
        labelValue: this.pageLabel,
        viewProductsLabel: this.viewProductsLabel,
        rangeProductLabel: this.rangeProductLabel,
        appProductsLabel: this.appProductsLabel,
        numberProductsOfAllProductsLabel: this.numberProductsOfAllProductsLabel,
        noResultsClearLink: this.noResultsClearLink,
        noResultsHeader: this.noResultsHeader,
        noResultsMessage: this.noResultsMessage,
        viewMoreLabel: this.viewMoreLabel,
        viewLessLabel: this.viewLessLabel,
        loadMoreLabel: this.loadMoreLabel,
        loadPreviousLabel: this.loadPreviousLabel,
      }, hostWithLocale: this.isPBS ? this.host : this.localeCode, name: this.name, currentNode: this.currentNode, filters: this.filters, filtrationSmartData: this.filtrationSmartData, navigationState: this.navigationState, productList: this.productIds, productUrlParams: this.productUrlParams || '', pills: this.pills, categories: this.categories, productsPerPage: this.paginationParams.productsPerPage, productsCount: this.productsCount, selectedPage: this.selectedPage, isLoading: this.isLoading, isMobileCategorySelected: this.isMobileCategorySelected, showDocuments: this.showDocuments, resultCount: this.resultsCount, firstLoadedRecNum: this.firstLoadedRecNum, lastLoadedRecNum: this.lastLoadedRecNum, richText: this.richText, enableCommerceConnector: this.enableCommerceConnector, showBuyOnline: this.showBuyOnline, selectedSectionsCount: this.selectedSectionsCount, productCtas: this.productCtas, showCompare: !this.isPBS, isPBS: this.isPBS, enableAppRouting: this.isExternalConsumer ? !this.externalAppRoutingEnabled : this.isPBS, isExternalConsumer: this.isExternalConsumer, externalUrlConfig: this.externalUrlConfig, externalFavoriteConfig: this.externalFavoriteConfig }));
    this.renderDocumentListing = (name, isSoftware) => {
      var _a, _b, _c;
      return (!isEmpty_1(this.tabs.documents) && (h("pes-document-listing", { name: name, apiEndpoint: this.tabs.documents.apiEndpoint, documentDetailsUrl: this.tabs.documents.documentDetailsUrl, enableDocumentDetailsUrl: false, country: getCountry(this.localeCode), language: getLanguage(this.localeCode), pageType: "range", resourceId: this.id, software: isSoftware, view: "smallcard", myFavorites: false, applicationSource: ((_a = this.documentListing) === null || _a === void 0 ? void 0 : _a.appSource) || ((_c = (_b = this.tabs) === null || _b === void 0 ? void 0 : _b.documents) === null || _c === void 0 ? void 0 : _c.appSource) })));
    };
    this.renderSoftwareRegistration = () => {
      return (!isEmpty_1(this.tabs.softwareRegistration) && (h("pes-range-software-registration-tab", { url: this.tabs.softwareRegistration.softwareRegistrationUrl })));
    };
    this.getTabs = () => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const productsTab = {
        title: (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.title,
        renderFunction: this.renderProductsTab,
        hash: TAB_NAMES.Products,
        hidden: false,
        hideHash: true,
      };
      const registrationTab = {
        title: this.softwareRegistrationLabel,
        renderFunction: this.renderSoftwareRegistration,
        hash: TAB_NAMES.SoftwareRegistration,
        hidden: isEmpty_1((_c = this.tabs) === null || _c === void 0 ? void 0 : _c.softwareRegistration),
      };
      const webinarsTab = {
        title: this.rangeWebinarsAndResourcesLabel,
        renderFunction: this.renderWebinarsAndResources,
        hash: TAB_NAMES.WebinarAndResources,
        hidden: isEmpty_1((_d = this.tabs) === null || _d === void 0 ? void 0 : _d.webinarsAndResources),
      };
      return [
        ((_f = (_e = this.tabs) === null || _e === void 0 ? void 0 : _e.products) === null || _f === void 0 ? void 0 : _f.showProductsTab) && productsTab,
        {
          title: this.rangePresentationLabel,
          renderFunction: this.renderPresentationTab,
          hash: TAB_NAMES.Presentation,
          hidden: false,
        },
        {
          title: (_h = (_g = this.tabs) === null || _g === void 0 ? void 0 : _g.documents) === null || _h === void 0 ? void 0 : _h.documentLabel,
          renderFunction: () => this.renderDocumentListing(TAB_NAMES.Documents, false),
          hash: TAB_NAMES.Documents,
          hidden: !this.documentsTabEnabled[TAB_NAMES.Documents],
        },
        {
          title: this.rangeSoftwareAndFirmwareLabel,
          renderFunction: () => this.renderDocumentListing(TAB_NAMES.Software, true),
          hash: TAB_NAMES.Software,
          hidden: !this.documentsTabEnabled[TAB_NAMES.Software],
        },
        !this.isPBS && registrationTab,
        !this.isPBS && webinarsTab,
      ];
    };
  }
  handlePreviousNodeSelected() {
    this.nodesNavigation.pop();
    this.nodeSelected.emit(this.nodesNavigation.pop());
  }
  handleNodeSelected(event) {
    const { url, id, name, nodeReference, navigationState, nodes } = event.detail;
    this.isHighLevelNode = true;
    this.PBSoffset = 0;
    this.currentReference = url;
    this.navigationState = `?n=${navigationState}`;
    this.nodesNavigation.push(event.detail);
    this.currentNode = calculateCurrentNodeParams({
      nodeReference,
      id,
      name,
      nodes,
      navigationState: this.navigationState,
    }, join(this.localeCode, 'product-range', this.rangeReference), nodeReference, this.backLabel, url.replace(`/${nodeReference}`, ''), this.backLabel);
    this.seoURl = `product-range/${this.rangeReference}/${nodeReference}`;
    this.initialNavigationState = this.navigationState;
    this.initialHighLevelSeoUrl = this.seoURl;
    this.loadFilters();
  }
  documentListingReady(event) {
    const { name, hasDocuments } = event.detail;
    this.documentsTabEnabled = Object.assign(Object.assign({}, this.documentsTabEnabled), { [name]: hasDocuments });
  }
  onFilterStateChanged(event) {
    const { lastChangedFilterId: filterId } = event.detail;
    if (filterId) {
      const { navigationState, rootSectionId, seoUrl } = this.filtersNormalized.entities.filter[filterId];
      this.changeFilter(navigationState, rootSectionId === 'product.category' ? seoUrl : '');
    }
  }
  onSelectCategoryHandler(event) {
    this.setActive(event.detail);
    this.isMobileCategorySelected = true;
  }
  resetAllFiltersHandler() {
    this.isResetFilters = true;
    this.changeFilter(this.initialNavigationState, this.isHighLevelNode
      ? this.initialHighLevelSeoUrl
      : join(this.localeCode, 'product-range', this.initialNodeIds.rangePath));
  }
  onToggleMobileViewVisibility(event) {
    const { detail } = event;
    if (detail === null || detail === void 0 ? void 0 : detail.restore) {
      this.setActive(this.navigationStateBeforeFilterMobileViewOpen);
    }
    else if (!detail) {
      this.navigationStateBeforeFilterMobileViewOpen = this.navigationState;
    }
  }
  removePillHandler(event) {
    const navigationState = event.detail;
    this.changeFilter(navigationState);
  }
  productClickHandler(event) {
    const productRef = event.detail;
    if (this.onProductClick) {
      this.onProductClick(productRef);
    }
  }
  choosePage(event) {
    this.selectedPage = event.detail;
    const { productsPerPage } = this.paginationParams;
    this.paginationParams = Object.assign(Object.assign({}, this.paginationParams), { offset: productsPerPage * (this.selectedPage - 1) });
    this.PBSoffset = productsPerPage * (this.selectedPage - 1);
    this.loadProducts();
  }
  mobileCategoryReset() {
    this.isMobileCategorySelected = false;
  }
  trackAnalyticsEventListener(e) {
    const { event } = e.detail;
    if (event === 'refinementStateChanged') {
      const { refinementId } = e.detail;
      const { value, nativeFilterCategory, parentCategoryId, rootSectionId, navigationState } = this.filtersNormalized.entities.filter[refinementId];
      const nativeParentCategoryId = parentCategoryId.slice(`${nativeFilterCategory}_`.length, parentCategoryId.length);
      const filterCategory = nativeFilterCategory || rootSectionId;
      const extraParams = {
        filterCategory,
        filterSubCategory: filterCategory !== nativeParentCategoryId ? nativeParentCategoryId : undefined,
        filterName: value.slice(0, value.indexOf(`_${navigationState}`)),
      };
      processGlobalAnalyticsEvent(e, extraParams);
    }
  }
  get paginationParams() {
    const searchParams = new URLSearchParams(window.location.search);
    const offset = searchParams.has(OFFSET_PARAM_NAME)
      ? Number(searchParams.get(OFFSET_PARAM_NAME))
      : 0;
    const productsPerPage = searchParams.has(PRODUCTS_PER_PAGE_PARAM_NAME)
      ? Number(searchParams.get(PRODUCTS_PER_PAGE_PARAM_NAME))
      : Number(this.tabs.products.numberProductsOnRangePage);
    return { offset, productsPerPage };
  }
  set paginationParams(state) {
    const searchParams = new URLSearchParams(window.location.search);
    if (state) {
      searchParams.set(OFFSET_PARAM_NAME, state.offset.toString());
      searchParams.set(PRODUCTS_PER_PAGE_PARAM_NAME, state.productsPerPage.toString());
    }
    else {
      searchParams.delete(OFFSET_PARAM_NAME);
      searchParams.delete(PRODUCTS_PER_PAGE_PARAM_NAME);
    }
    if (!this.isPBS) {
      this.navigationPush(searchParams);
    }
  }
  get nodeIds() {
    return getRangeNodesIds(!this.isPBS ? window.location.pathname : this.currentReference, this.rangeReference);
  }
  changeFilter(navigationState, seoUrl) {
    if (!this.isPBS) {
      const searchParams = new URLSearchParams(window.location.search);
      const currentNavigationState = getNavigationState(navigationState);
      if (!currentNavigationState && navigationState.includes('subnode-id')) {
        searchParams.set('subnode-id', navigationState.replace('?subnode-id=', ''));
        searchParams.delete(NAVIGATION_STATE_PARAM_NAME);
      }
      else {
        searchParams.set(NAVIGATION_STATE_PARAM_NAME, currentNavigationState);
      }
      searchParams.delete(OFFSET_PARAM_NAME);
      searchParams.delete(PRODUCTS_PER_PAGE_PARAM_NAME);
      this.navigationPush(searchParams, seoUrl);
    }
    this.setActive(navigationState, seoUrl);
  }
  navigationPush(searchParams, path = '') {
    window.history.pushState({ navigationState: this.navigationState }, '', `${path}?${searchParams.toString()}${window.location.hash}`);
  }
  get categories() {
    const filters = (this.filters && this.filters[0]) || {};
    const categories = filters.filterRefinements || [];
    return categories.map(({ checked, navigationState, label }) => ({
      checked,
      navigationState,
      label,
    }));
  }
  get productIds() {
    return this.products.map((productInfo) => productInfo.repositoryId).join();
  }
  get activeCategory() {
    var _a;
    const category = this.filters && this.filters[0];
    return category && ((_a = category.filterRefinements.find((i) => i.checked)) === null || _a === void 0 ? void 0 : _a.label);
  }
  initNavigationState(navigationState) {
    this.initialNavigationState = navigationState;
  }
  static mapFiltersData(data) {
    const { characteristicName, isCategory, filterCategory, filterSubCategory, rangeFilterRefinements, subcharacteristics, } = data;
    return {
      characteristicName,
      isCategory,
      filterCategory,
      filterSubCategory,
      filterRefinements: rangeFilterRefinements,
      subcharacteristics: subcharacteristics.map(RangeTabs.mapFiltersData),
    };
  }
  loadFilters() {
    this.isLoading = true;
    const { nodeId, categoryId } = this.isResetFilters ? this.initialNodeIds : this.nodeIds;
    const navigation = this.navigationState.includes('+')
      ? replacePlusWithSpace(this.navigationState)
      : this.navigationState;
    const url = !this.isPBS
      ? getFiltersUrl(this.localeCode, this.endpoint, this.id, this.navigationState, nodeId, categoryId)
      : `${this.host}${this.endpoint}api/range/filters/${this.id}/${getNodeIds(this.isHighLevelNode ? this.seoURl : this.currentReference)}${navigation}`;
    getData(false, url)
      .then(({ filters, pills, selectedFiltersQty }) => {
      filters = filters !== null && filters !== void 0 ? filters : [];
      this.updateState(filters.map(RangeTabs.mapFiltersData));
      this.pills = pills !== null && pills !== void 0 ? pills : [];
      this.selectedSectionsCount = selectedFiltersQty > 0 ? selectedFiltersQty : 0;
    })
      .catch((error) => {
      this.isLoading = false;
      console.error(error);
    })
      .finally(() => {
      if (this.isResetFilters) {
        this.isResetFilters = false;
      }
    });
  }
  updateState(filters) {
    this.filters = filters;
    if ((filters === null || filters === void 0 ? void 0 : filters.length) && !this.isFirstRenderOfNodes) {
      filters.forEach((facet) => {
        facet.nativeFilterCategory = facet.filterCategory;
        changeCategoriesFields(facet.filterCategory, facet.subcharacteristics);
      });
      this.filtersNormalized = normalizeFilters(filters);
      this.filtrationSmartData = clearNormalizedFilterData(this.filtersNormalized);
    }
    this.isFirstRenderOfNodes = false;
    this.loadProducts();
  }
  loadProducts() {
    var _a;
    this.isLoading = true;
    const currentNavigationState = this.navigationState.includes('subnode-id')
      ? this.navigationState
      : this.navigationState.replace(/\?n/g, '?N');
    const navState = currentNavigationState.replace(/subnode-id/g, 'subNodeId');
    const { offset, productsPerPage } = this.paginationParams;
    const modifiedNavState = navState.includes('+') ? replacePlusWithSpace(navState) : navState;
    const modifiedSeoUrl = this.seoURl && !((_a = this.seoURl) === null || _a === void 0 ? void 0 : _a.includes('product-range')) && this.isHighLevelNode
      ? this.initialHighLevelSeoUrl
      : this.seoURl;
    const modifiedRangeReference = this.isHighLevelNode
      ? this.currentReference.replace(LOCALE_REGEXP, '')
      : this.rangeReference;
    const PBSUrl = this.seoURl
      ? `${this.host}${modifiedSeoUrl}${modifiedNavState}&No=${this.PBSoffset}&Nrpp=${productsPerPage}&format=json`
      : `${this.host}product-range/${modifiedRangeReference}${modifiedNavState}&No=${this.PBSoffset}&Nrpp=${productsPerPage}&format=json`;
    const url = !this.isPBS
      ? getProductsUrl(this.currentNode.currentNodeUrl, navState, offset, productsPerPage)
      : PBSUrl;
    getData(false, url)
      .then((response) => {
      const parsedProducts = parseRecords(response);
      if (parsedProducts) {
        this.richText = parsedProducts.richText;
        this.setProductsInfo(parsedProducts.products);
      }
    })
      .finally(() => {
      this.isLoading = false;
      this.isTabsInitialized = true;
    });
  }
  setProductsInfo(productsInfo) {
    if (!productsInfo)
      return;
    const { totalNumRecs, firstRecNum, lastRecNum, recsPerPage, records } = productsInfo;
    this.productsCount = productsInfo.totalNumRecs;
    this.resultsCount = {
      firstRecNum,
      lastRecNum,
      recsPerPage,
      totalNumRecs,
    };
    if (!isMobile()) {
      this.firstLoadedRecNum = undefined;
      this.lastLoadedRecNum = undefined;
      this.products = [];
    }
    this.firstLoadedRecNum = this.firstLoadedRecNum === undefined
      ? firstRecNum
      : Math.min(firstRecNum, this.firstLoadedRecNum);
    this.lastLoadedRecNum = this.lastLoadedRecNum === undefined
      ? lastRecNum
      : Math.max(lastRecNum, this.lastLoadedRecNum);
    records.forEach((record, index) => {
      this.products[firstRecNum + index - 1] = record;
    });
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20;
    this.host = (_a = tryParse(this._host)) !== null && _a !== void 0 ? _a : this.host;
    this.localeCode = (_b = tryParse(this._localeCode)) !== null && _b !== void 0 ? _b : this.localeCode;
    this.productUrlParams = (_c = tryParse(this._productUrlParams)) !== null && _c !== void 0 ? _c : this.productUrlParams;
    this.endpoint = (_d = tryParse(this._endpoint)) !== null && _d !== void 0 ? _d : this.endpoint;
    this.appProductsLabel = (_e = tryParse(this._appProductsLabel)) !== null && _e !== void 0 ? _e : this.appProductsLabel;
    this.commonFiltersFilterBy = (_f = tryParse(this._commonFiltersFilterBy)) !== null && _f !== void 0 ? _f : this.commonFiltersFilterBy;
    this.facetButtonResetAllLabel = (_g = tryParse(this._facetButtonResetAllLabel)) !== null && _g !== void 0 ? _g : this.facetButtonResetAllLabel;
    this.facetButtonViewLessFilters = (_h = tryParse(this._facetButtonViewLessFilters)) !== null && _h !== void 0 ? _h : this.facetButtonViewLessFilters;
    this.facetButtonViewMoreFilters = (_j = tryParse(this._facetButtonViewMoreFilters)) !== null && _j !== void 0 ? _j : this.facetButtonViewMoreFilters;
    this.nextLabel = (_k = tryParse(this._nextLabel)) !== null && _k !== void 0 ? _k : this.nextLabel;
    this.pageLabel = (_l = tryParse(this._pageLabel)) !== null && _l !== void 0 ? _l : this.pageLabel;
    this.noResultsClearLink = (_m = tryParse(this._noResultsClearLink)) !== null && _m !== void 0 ? _m : this.noResultsClearLink;
    this.noResultsHeader = (_o = tryParse(this._noResultsHeader)) !== null && _o !== void 0 ? _o : this.noResultsHeader;
    this.noResultsMessage = (_p = tryParse(this._noResultsMessage)) !== null && _p !== void 0 ? _p : this.noResultsMessage;
    this.numberProductsOfAllProductsLabel = (_q = tryParse(this._numberProductsOfAllProductsLabel)) !== null && _q !== void 0 ? _q : this.numberProductsOfAllProductsLabel;
    this.previousLabel = (_r = tryParse(this._previousLabel)) !== null && _r !== void 0 ? _r : this.previousLabel;
    this.rangeProductLabel = (_s = tryParse(this._rangeProductLabel)) !== null && _s !== void 0 ? _s : this.rangeProductLabel;
    this.rangeProductsFiltersLabel = (_t = tryParse(this._rangeProductsFiltersLabel)) !== null && _t !== void 0 ? _t : this.rangeProductsFiltersLabel;
    this.viewLessLabel = (_u = tryParse(this._viewLessLabel)) !== null && _u !== void 0 ? _u : this.viewLessLabel;
    this.viewMoreLabel = (_v = tryParse(this._viewMoreLabel)) !== null && _v !== void 0 ? _v : this.viewMoreLabel;
    this.viewProductsLabel = (_w = tryParse(this._viewProductsLabel)) !== null && _w !== void 0 ? _w : this.viewProductsLabel;
    this.rangePresentationLabel = (_x = tryParse(this._rangePresentationLabel)) !== null && _x !== void 0 ? _x : this.rangePresentationLabel;
    this.rangeWebinarsAndResourcesLabel = (_y = tryParse(this._rangeWebinarsAndResourcesLabel)) !== null && _y !== void 0 ? _y : this.rangeWebinarsAndResourcesLabel;
    this.softwareRegistrationLabel = (_z = tryParse(this._softwareRegistrationLabel)) !== null && _z !== void 0 ? _z : this.softwareRegistrationLabel;
    this.rangeSoftwareAndFirmwareLabel = (_0 = tryParse(this._rangeSoftwareAndFirmwareLabel)) !== null && _0 !== void 0 ? _0 : this.rangeSoftwareAndFirmwareLabel;
    this.loadMoreLabel = (_1 = tryParse(this._loadMoreLabel)) !== null && _1 !== void 0 ? _1 : this.loadMoreLabel;
    this.loadPreviousLabel = (_2 = tryParse(this._loadPreviousLabel)) !== null && _2 !== void 0 ? _2 : this.loadPreviousLabel;
    this.descriptionBigger = (_3 = tryParse(this._descriptionBigger)) !== null && _3 !== void 0 ? _3 : this.descriptionBigger;
    this.id = (_4 = tryParse(this._id)) !== null && _4 !== void 0 ? _4 : this.id;
    this.name = (_5 = tryParse(this._name)) !== null && _5 !== void 0 ? _5 : this.name;
    this.navigationState = (_6 = tryParse(this._navigationState)) !== null && _6 !== void 0 ? _6 : this.navigationState;
    this.rangeReference = (_7 = tryParse(this._rangeReference)) !== null && _7 !== void 0 ? _7 : this.rangeReference;
    this.showDocuments = (_8 = tryParse(this._showDocuments)) !== null && _8 !== void 0 ? _8 : this.showDocuments;
    this.tabs = (_9 = tryParse(this._tabs)) !== null && _9 !== void 0 ? _9 : this.tabs;
    this.enableCommerceConnector = (_10 = tryParse(this._enableCommerceConnector)) !== null && _10 !== void 0 ? _10 : this.enableCommerceConnector;
    this.showBuyOnline = (_11 = tryParse(this._showBuyOnline)) !== null && _11 !== void 0 ? _11 : this.showBuyOnline;
    this.currentReference = (_12 = tryParse(this._currentReference)) !== null && _12 !== void 0 ? _12 : this.currentReference;
    this.externalUrlConfig = (_13 = tryParse(this._externalUrlConfig)) !== null && _13 !== void 0 ? _13 : this.externalUrlConfig;
    this.externalFavoriteConfig = (_14 = tryParse(this._externalFavoriteConfig)) !== null && _14 !== void 0 ? _14 : this.externalFavoriteConfig;
    if (!this.currentReference) {
      this.currentReference = this.isPBS
        ? this.rangeReference
        : getCurrentReference(Boolean((_17 = (_16 = (_15 = this.tabs) === null || _15 === void 0 ? void 0 : _15.products) === null || _16 === void 0 ? void 0 : _16.nodes) === null || _17 === void 0 ? void 0 : _17.length), 'product-range');
    }
    this.currentNode = calculateCurrentNodeParams({
      nodeReference: this.rangeReference,
      id: 'root',
      name: this.name,
      nodes: (_18 = this.tabs) === null || _18 === void 0 ? void 0 : _18.products.nodes,
    }, join(this.localeCode, 'product-range', this.rangeReference), this.currentReference, this.backLabel);
    const { offset, productsPerPage } = this.paginationParams;
    this.selectedPage = Math.floor(offset / productsPerPage) + 1;
    const searchParams = new URLSearchParams(window.location.search);
    const navigationStateFromUrl = searchParams.has(NAVIGATION_STATE_PARAM_NAME)
      ? searchParams.get(NAVIGATION_STATE_PARAM_NAME)
      : null;
    const navigationStateFromNode = this.currentNode.navigationState;
    const segments = window.location.pathname
      .split('/')
      .filter((pathSegment) => pathSegment !== '');
    if (navigationStateFromUrl) {
      this.navigationState = navigationStateFromUrl;
    }
    else if (this.currentReference === segments[segments.length - 1] && navigationStateFromNode) {
      this.navigationState = navigationStateFromNode;
    }
    this.initNavigationState(this.navigationState);
    this.initialNodeIds = this.nodeIds;
    if (this.navigationState) {
      this.isMobileCategorySelected = true;
    }
    this.loadFilters();
    window.addEventListener('popstate', this.handlePopState);
    if (((_19 = this.nodes) === null || _19 === void 0 ? void 0 : _19.length) && this.isPBS) {
      this.isFirstRenderOfNodes = true;
    }
    this.nodesNavigation.push({
      url: this.currentReference,
      id: 'root',
      name: this.name,
      image: null,
      nodeReference: this.rangeReference,
      navigationState: getNavigationState(this.navigationState),
      nodes: (_20 = this.tabs) === null || _20 === void 0 ? void 0 : _20.products.nodes,
    });
  }
  disconnectedCallback() {
    window.removeEventListener('popstate', this.handlePopState);
  }
  setActive(navigationState, seoUrl) {
    this.PBSoffset = 0;
    this.selectedPage = 1;
    this.products = [];
    this.navigationState = navigationState;
    if (seoUrl) {
      this.seoURl = seoUrl;
    }
    this.loadFilters();
    if (this.filters && this.isPBS) {
      this.seoURl = this.isResetFilters && !this.isHighLevelNode
        ? ''
        : getSeoUrl(this.filters[0].filterRefinements, this.navigationState);
    }
  }
  render() {
    const tabs = this.getTabs().filter(Boolean);
    return this.isTabsInitialized && h("pes-tabs", { class: "range-tabs", tabs: tabs });
  }
  get el() { return getElement(this); }
};
RangeTabs.style = rangeTabsCss;

export { RangeTabs as pes_range_tabs };
